import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';

export type UpdateAddressPayload = {
  base_lead_id: string;
  lead_id: string;
  country: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
};

export type UpdateAddressResponse = {
  status: string;
  message: string;
};

export const updateAddress = (
  data: UpdateAddressPayload
): Promise<UpdateAddressResponse> => {
  return axios.patch('/batches/v1/edit-address', data);
};

// Mock handler
const mockUpdateAddressResponse: UpdateAddressResponse = {
  status: 'SUCCESS',
  message: 'Profiles are updated',
};

export const updateAddressMockHandler = http.patch(
  `${env.API_URL}/batches/v1/edit-address`,
  async ({ request }): Promise<HttpResponse<UpdateAddressResponse>> => {
    const body = (await request.json()) as UpdateAddressPayload;

    // Validate required fields
    const requiredFields = [
      'base_lead_id',
      'lead_id',
      'country',
      'address',
      'city',
      'state',
      'zipcode',
    ];

    for (const field of requiredFields) {
      if (!body[field as keyof UpdateAddressPayload]) {
        return HttpResponse.json(
          {
            status: 'FAILURE',
            message: `${field} is required`,
          },
          { status: 400 }
        );
      }
    }

    return HttpResponse.json(mockUpdateAddressResponse);
  }
);
